import React from "react";
import { Table } from "react-bootstrap";
import { getGrade } from "../../utils/gradeUtils";

const TerminalMarksTable = ({ data, term, year }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-muted">No terminal entries found</p>
      </div>
    );
  }

  return (
    <div className="mb-3">
      <h5 className="text-center mb-3" style={{ fontSize: "1.1rem" }}>
        {term === 1 ? "1st" : term === 2 ? "2nd" : "3rd"} Terminal Marks -{" "}
        {year}
      </h5>
      <Table striped bordered hover responsive size="sm">
        <thead className="table-primary">
          <tr>
            <th className="py-2" style={{ fontSize: "0.8rem" }}>
              Subject
            </th>
            <th className="py-2" style={{ fontSize: "0.8rem" }}>
              Full Marks
            </th>
            <th className="py-2" style={{ fontSize: "0.8rem" }}>
              Highest Marks
            </th>
            <th className="py-2" style={{ fontSize: "0.8rem" }}>
              Oral Marks
            </th>
            <th className="py-2" style={{ fontSize: "0.8rem" }}>
              Writing Marks
            </th>
            <th className="py-2" style={{ fontSize: "0.8rem" }}>
              Total Marks
            </th>
            <th className="py-2" style={{ fontSize: "0.8rem" }}>
              In Percentage
            </th>
            <th className="py-2" style={{ fontSize: "0.8rem" }}>
              Grade
            </th>
          </tr>
        </thead>
        <tbody>
          {[...data]
            .sort(
              (a, b) => a.terminalSubject?.serial - b.terminalSubject?.serial
            )
            .map((entry, index) => (
              <tr key={index}>
                <td className="py-1" style={{ fontSize: "0.75rem" }}>
                  {entry.terminalSubject?.name || "N/A"}
                </td>
                <td className="py-1" style={{ fontSize: "0.75rem" }}>
                  {entry.terminalSubject?.mark || 0}
                </td>
                <td className="py-1" style={{ fontSize: "0.75rem" }}>
                  {entry.highestMark || 0}
                </td>
                <td className="py-1" style={{ fontSize: "0.75rem" }}>
                  <b>{parseFloat(entry.oralMark || 0).toFixed(2)}</b> (
                  {entry.terminalSubject?.oralMark || 0})
                </td>
                <td className="py-1" style={{ fontSize: "0.75rem" }}>
                  <b>{parseFloat(entry.writingMark || 0).toFixed(2)}</b> (
                  {entry.terminalSubject?.writingMark || 0})
                </td>
                <td className="py-1" style={{ fontSize: "0.75rem" }}>
                  <b>{parseFloat(entry.totalMark || 0).toFixed(2)}</b> (
                  {entry.terminalSubject?.mark || 0})
                </td>
                <td className="py-1" style={{ fontSize: "0.75rem" }}>
                  {entry.percentage ? entry.percentage.toFixed(2) : 0}%
                </td>
                <td className="py-1" style={{ fontSize: "0.75rem" }}>
                  <span
                    className={`badge ${
                      entry.percentage >= 50 ? "bg-success" : "bg-danger"
                    }`}
                    style={{ fontSize: "0.65rem" }}
                  >
                    {getGrade(entry.percentage || 0)}
                  </span>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
};

export default TerminalMarksTable;
